import axios from 'axios';
export default {
    getProducts(context) {
        return axios.get('/api/shop/products').then(response => {
            context.commit('products', response.data);
        })
    },

    addToCart(context, payload) {
        context.commit('addToCart', payload);
    },

    buy({ state, commit }) {
        let buyerData = state.buyerData;
        let deliveryData = state.deliveryAddress;
        let delivery_additional_info = state.deliveryAdditionalInfo;
        let delivery_to_other_address = state.deliveryToOtherAddress;
        let delivery_to_phone_and_email = state.deliveryToPhoneAndEmail;
        let payment_type = state.paymentType;
        let delivery_to_prison = state.deliveryToPrison;
        let location_id = state.location;
        let prisonerData = state.prisonerData;
        let edeliveryData = state.edeliveryAddress;

        //console.log("SSSS");
        //console.log(edeliveryData);
        let letterType = "";
        if(delivery_to_prison){
            letterType = prisonerData.letter_type;
        } else {
            letterType = deliveryData.letter_type;
        }

        let requestData = {
            cart: state.cart,
            order: {
                ...buyerData,
                delivery_first_name: deliveryData.first_name,
                delivery_last_name: deliveryData.last_name,
                delivery_address: deliveryData.address,
                delivery_city: deliveryData.city,
                delivery_postal_code: deliveryData.postal_code,
                delivery_additional_info,
                delivery_to_other_address,
                delivery_to_phone_and_email,
                payment_type,
                delivery_to_prison,
                ...prisonerData,
                letter_type: letterType,
                location_id,
                edelivery_email: edeliveryData.email,
                edelivery_phone: edeliveryData.phone,
                invoice_data: state.invoiceData
            }
        }

        return axios.post("/api/shop/customer-orders/customer-order", requestData).then(response => {
            commit("order", response.data.order);
            return response;
        });
    },

    validateBuyerData(context, payload) {
        //console.log(payload);
        return axios.post("/api/shop/customer-orders/validate-buyer-data", payload).then(response => {
            if (response.data.status == "OK") {
                context.commit("buyerData", payload);
            } else {
                context.commit("buyerDataErrors", response.data.errors)
            }
            return response;
        })
    },

    validatePrisonerData(context, payload) {
        //console.log(payload);
        return axios.post("/api/shop/customer-orders/validate-prisoner-data", payload).then(response => {
            if (response.data.status == "OK") {
                context.commit("prisonerData", payload);
            } else {
                context.commit("prisonerDataErrors", response.data.errors)
            }
            return response;
        })
    },

    validateDeliveryData(context, payload) {
        //console.log(payload);
        return axios.post("/api/shop/customer-orders/validate-delivery-data", payload).then(response => {
            if (response.data.status == "OK") {
                context.commit("deliveryAddress", payload);
            } else {
                context.commit("deliveryDataErrors", response.data.errors)
            }
            return response;
        })
    },

    validateEDeliveryData(context, payload) {
        //console.log(payload);
        return axios.post("/api/shop/customer-orders/validate-edelivery-data", payload).then(response => {
            if (response.data.status == "OK") {
                context.commit("edeliveryAddress", payload);
            } else {
                context.commit("edeliveryDataErrors", response.data.errors)
            }
            return response;
        })
    },

    getLocations(context) {
        return axios.get("/api/shop/customer-orders/locations").then(response => {
            context.commit("locations", response.data);
            return response;
        })
    },

    validateInvoiceData(context, payload) {
        return axios.post("/api/shop/customer-orders/validate-invoice-data", payload).then(response => {
            if (response.data.status == "OK") {
                context.commit("invoiceData", payload);
            } else {
                context.commit("invoiceDataErrors", response.data.errors)
            }
            return response;
        })
    },

    getLetterOptions({ commit }) {
        return axios.get("/api/shop/products/delivery-options").then(response => {
            commit("letterOptions", response.data);
        })
    }
}